export type SearchResultLayout = "GRID" | "LIST" | undefined;

const SEARCH_RESULT_LAYOUT = {
    GRID: "GRID" as SearchResultLayout,
    LIST: "LIST" as SearchResultLayout
};

export default SEARCH_RESULT_LAYOUT;

export const { GRID, LIST } = SEARCH_RESULT_LAYOUT;
